import { render, staticRenderFns } from "./rule-list.vue?vue&type=template&id=295ffa9a&scoped=true"
import script from "./rule-list.vue?vue&type=script&lang=js"
export * from "./rule-list.vue?vue&type=script&lang=js"
import style0 from "./rule-list.vue?vue&type=style&index=0&id=295ffa9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295ffa9a",
  null
  
)

export default component.exports